__turbopack_context__.v({
  "btnGhost": "sidebar-module__3GJZrW__btnGhost",
  "btnPrimary": "sidebar-module__3GJZrW__btnPrimary",
  "btnSecondary": "sidebar-module__3GJZrW__btnSecondary",
  "emptyText": "sidebar-module__3GJZrW__emptyText",
  "enlaceItem": "sidebar-module__3GJZrW__enlaceItem",
  "enlaceLink": "sidebar-module__3GJZrW__enlaceLink",
  "enlaceType": "sidebar-module__3GJZrW__enlaceType",
  "identitySection": "sidebar-module__3GJZrW__identitySection",
  "infoCard": "sidebar-module__3GJZrW__infoCard",
  "infoCardStretched": "sidebar-module__3GJZrW__infoCardStretched",
  "infoSection": "sidebar-module__3GJZrW__infoSection",
  "infoSectionCount": "sidebar-module__3GJZrW__infoSectionCount",
  "infoSectionIcon": "sidebar-module__3GJZrW__infoSectionIcon",
  "infoSectionIconSvg": "sidebar-module__3GJZrW__infoSectionIconSvg",
  "infoSectionTitle": "sidebar-module__3GJZrW__infoSectionTitle",
  "lineRow": "sidebar-module__3GJZrW__lineRow",
  "lineRowIcon": "sidebar-module__3GJZrW__lineRowIcon",
  "lineRowIconBox": "sidebar-module__3GJZrW__lineRowIconBox",
  "lineRowText": "sidebar-module__3GJZrW__lineRowText",
  "lineRowUdaMark": "sidebar-module__3GJZrW__lineRowUdaMark",
  "sidebar": "sidebar-module__3GJZrW__sidebar",
});
